export default __webpack_public_path__ + "static/media/facebook.00f72a9c.svg";